// Customer utility functions

const CUSTOMER_STATUS = Object.freeze({
    NEW: 1, // новички (новый пользователь в течение 7 дней после регистрации)
    GOLD: 2, // "золотой" - от 711 дней между первым и последним выполненным заказом
    SILVER: 3, // "серебряный" - от 256 дней до 711 дней между первым и последним выполненным заказом
    NEUTRAL: 4, // "нейтральный" - до 255 дней между первым и последним выполненным заказом
    SLEEPING: 5, // уснувшие (без заказов от 21 до 60 дней)
    CHURNED: 6 // отвалился (нет заказов больше 61 дня)
});

const ORDERS_FREQUENCY = Object.freeze({
    WEEKLY_0: 1, // Без заказов (0 заказов за 30 дней)
    WEEKLY_1: 2, // 1 заказ в неделю (до 4 заказов включительно за 30 дней)
    WEEKLY_2_3: 3, // 2-3 заказа в неделю (от 5 до 15 заказов включительно за 30 дней)
    WEEKLY_4_PLUS: 4 // более 4 заказов в неделю (за 30 дней от 16 заказов)
});

/**
 * Convert customer status code to text
 * @param {number} statusCode - Status code (1, 2, 3, 4, 5, 6)
 * @returns {string|null} - Status text or null
 */
export function getCustomerStatusText(statusCode) {
    const statusMap = {
        [CUSTOMER_STATUS.NEW]: 'Новичок',
        [CUSTOMER_STATUS.GOLD]: 'Золотой',
        [CUSTOMER_STATUS.SILVER]: 'Серебряный',
        [CUSTOMER_STATUS.NEUTRAL]: 'Нейтральный',
        [CUSTOMER_STATUS.SLEEPING]: 'Уснувший',
        [CUSTOMER_STATUS.CHURNED]: 'Отвалился'
    };
    
    return statusMap[statusCode] || null;
}

export function getCustomerStatusBadge(statusCode) {
    const statusMap = {
        [CUSTOMER_STATUS.NEW]: 'info',
        [CUSTOMER_STATUS.GOLD]: 'success',
        [CUSTOMER_STATUS.SILVER]: 'success',
        [CUSTOMER_STATUS.NEUTRAL]: 'secondary',
        [CUSTOMER_STATUS.SLEEPING]: 'danger',
        [CUSTOMER_STATUS.CHURNED]: 'danger'
    };
    
    return statusMap[statusCode] || null;
}

/**
 * Convert orders frequency code to text
 * @param {number} frequencyCode - Frequency code (1, 2, 3)
 * @returns {string|null} - Frequency text or null
 */
export function getOrdersFrequencyText(frequencyCode) {
    const frequencyMap = {
        [ORDERS_FREQUENCY.WEEKLY_0]: 'Без заказов',
        [ORDERS_FREQUENCY.WEEKLY_1]: '1 заказ в неделю',
        [ORDERS_FREQUENCY.WEEKLY_2_3]: '2-3 заказа в неделю',
        [ORDERS_FREQUENCY.WEEKLY_4_PLUS]: 'более 4 заказов в неделю'
    };
    
    return frequencyMap[frequencyCode] || null;
}

export { CUSTOMER_STATUS, ORDERS_FREQUENCY }; 